































import {
  defineComponent,
  computed
} from '@nuxtjs/composition-api';

import { SkeletonLoader } from '~/components';
import PromoItem from '../components/PromoItem.vue';
import { ObserveVisibility } from 'vue-observe-visibility';
import Vue from 'vue';

Vue.directive('observe-visibility', ObserveVisibility);

export default defineComponent({
  name: 'PromosGrid',
  components: {
    PromoItem,
    SkeletonLoader
  },
  props: {
    promos: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    isPromoListing: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const sortedPromos = computed(() => {
      if (props.isPromoListing) {
        return props.promos.filter((item) => item['is_enabled']);
      }
      return props.promos.sort((a, b) => a['position'] - b['position']);
    });

    const visibilityChanged = (isVisible, entry) => {
      if (isVisible) {
        entry.target.classList.remove('slide-fade');
      }
    };

    return {
      sortedPromos,
      visibilityChanged,
    };
  }
});
